<template>
  <div class="maindiv news-wrap">
    <div class="list-bg news-bg"></div>
    <div class="discs list htmldiv">
      <div class="cont pt50 pl15">
        <video muted="true" autoplay="true" controls="true" src="https://wisdomschool-1309900867.cos.ap-nanjing.myqcloud.com/upload_files%2FSchool%2F2023050109253597_video.mp4"
               style="height:600px;margin-bottom:25px"></video>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "Video"
}
</script>

<style scoped>
.news-bg{background: url(../../assets/images/index_05_01.jpg) no-repeat center top;}
.discs{marign-left: 11px;}
.discs .cont{text-align: center;}
</style>



// WEBPACK FOOTER //
// src/pages/index/Video.vue